import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/ic_facebook.svg")